export default "__VITE_ASSET__BYSjhkmd__"